import { adalGraphFetch } from "../adalConfig";
import { IOrganizationInfo } from "../interfaces/IOrganizationInfo";
import { User } from "@microsoft/microsoft-graph-types";

class GraphService {
  public async getOrganizationInfo(): Promise<IOrganizationInfo> {
    try {
      const response = await adalGraphFetch(
        fetch,
        "https://graph.microsoft.com/v1.0/organization?$select=id,displayName,verifiedDomains",
        {
          method: "GET",
          headers: {
            "Accept": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch organization info: ${response.statusText}`);
      }

      const data = await response.json();
      // Microsoft Graph returns an array of organizations, but typically there's only one
      return data.value[0];
    } catch (error) {
      console.error("Error fetching organization information:", error);
      throw error;
    }
  }

  public async getCurrentUser(): Promise<User> {
    try {
      const response = await adalGraphFetch(
        fetch,
        "https://graph.microsoft.com/v1.0/me?$select=displayName,mail,mobilePhone",
        {
          method: "GET",
          headers: {
            "Accept": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch user: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  }
}

export const graphService = new GraphService();
